import { Setting } from './tab-link.setting';

export class TabLink extends Setting {}
